<template lang="pug">
.base-card(
  :class="[variant, { 'is-expandable': expandable, expanded }]"
  tabindex="0"
  role="button"
  :aria-expanded="expandable ? expanded.toString() : undefined"
  @click="expandable && toggle()"
  @keydown.enter.self.prevent="expandable && toggle()"
  @keydown.space.self.prevent="expandable && toggle()"
)
  slot(name="header")
  div.base-card__body(v-show="!expandable || expanded")
    slot()
</template>

<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps({
  variant: { type: String, default: '' }, // e.g. 'base-card--location'
  expandable: { type: Boolean, default: false },
});

const expanded = ref(false);
function toggle() {
  expanded.value = !expanded.value;
}
</script>

<style scoped lang="scss">
.base-card {
  background: #fff;
  border-radius: $border-radius-xl;
  transition: box-shadow 0.2s;
  outline: none;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }
  &:focus-visible {
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);
  }

  &--callback {
    max-width: 400px;
  }

  &.is-expandable {
    cursor: pointer;
  }
}
</style>
